const openEmailClient = (): Window | null =>
  window.open(
    `mailto:heal@firstcarephysiotherapyandsportsclinic.co.uk?subject=I'm%20interested&body=Thanks%20for%20registering%20your%20interest%2C%20please%20add%20the%20following%20and%20hit%20send%0A%0A-%20What%20are%20you%20looking%20for%20help%20with%0A-%20Do%20you%20have%20a%20contact%20mobile%20that%20we%20can%20contact%20you%20on%3F%0A%0A`
  );

export default openEmailClient;
